import React from 'react'

const OnboardContext = React.createContext()

export default OnboardContext
